import { WprValueMapSetter } from '../../../wpr-framework/model/WprValueMapSetter';
import { WprValueMap } from '../../../wpr-framework/model/WprValueMap';

/**
 * 旅行人数バリューマップ
 */
export class PersonValueMap {
	// static メソッド  --------------------------------------------------------
	/**
   * ValueMap設定処理
   * @param vmSetter ValueMapセッター
   */
	public static addValueMap(vmSetter: WprValueMapSetter): void {
		const vm = new WprValueMap();
		for (let i = 1; i <= 5; i++) {
			vm.addValue(i, `${i}`);
		}
		vmSetter.addValueMap('person', vm);
	}
	// -------------------------------------------------------------------------
}